import { IconBan, IconCheck, IconHourglassHigh, IconX } from '@tabler/icons-react';
import clsx from 'clsx';

export interface IMatchStatus {
  variant?:
    | 'QUEUED'
    | 'UNVERIFIED'
    | 'VERIFIED'
    | 'BANNED'
    | 'DEACTIVATED'
    | 'NOSHOW'
    | 'DRAFT'
    | 'ANONYMIZED'
    | 'SKIPPED'
    | 'APPROVED'
    | 'REJECTED'
    | 'PENDING'
    | 'CREATED'
    | 'FLEX'
    | 'ACTIVE'
    | 'INACTIVE';
  children: React.ReactNode;
}

const variantStyle = {
  QUEUED: 'text-labels-darkGreyText bg-labels-darkGreyBackground border-labels-darkGreyText border',
  UNVERIFIED: 'text-labels-darkGreyText bg-labels-darkGreyBackground border-labels-darkGreyText border',
  DRAFT: 'text-labels-darkGreyText bg-labels-darkGreyBackground border-labels-darkGreyText border',
  VERIFIED: 'text-labels-greenText bg-labels-greenBackground border-labels-greenText border',
  BANNED: 'text-labels-redText bg-labels-redBackground border-labels-redText border',
  DEACTIVATED: 'text-labels-orangeText bg-labels-orangeBackground border-labels-orangeText border',
  NOSHOW: 'text-labels-orangeText bg-labels-orangeBackground border-labels-orangeText border',
  ANONYMIZED: 'text-labels-darkGreyText bg-labels-darkGreyBackground border-labels-darkGreyText border',
  CREATED: 'text-labels-orangeText bg-labels-orangeBackground border-labels-orangeText border',
  SKIPPED: 'text-labels-redText bg-labels-redBackground border-labels-redText border',
  APPROVED: 'text-labels-greenText bg-labels-greenBackground border-labels-greenText border',
  REJECTED: 'text-labels-redText bg-labels-redBackground border-labels-redText border',
  PENDING: 'text-labels-orangeText bg-labels-orangeBackground border-labels-orangeText border',
  ACTIVE: 'text-labels-greenText bg-labels-greenBackground border-labels-greenText border',
  INACTIVE: 'text-labels-redText bg-labels-redBackground border-labels-redText border',
  FLEX: 'text-white bg-black border-labels-blackText border',
};

const getIconForStatus = (variant: IMatchStatus['variant']) => {
  switch (variant) {
    case 'QUEUED':
      return <IconHourglassHigh size={15} />;
    case 'UNVERIFIED':
      return <IconX size={15} />;
    case 'DRAFT':
      return <IconHourglassHigh size={15} />;
    case 'VERIFIED':
    case 'ACTIVE':
    case 'APPROVED':
      return <IconCheck size={15} />;
    case 'BANNED':
      return <IconBan size={15} />;
    case 'DEACTIVATED':
    case 'NOSHOW':
    case 'ANONYMIZED':
    case 'INACTIVE':
    case 'REJECTED':
      return <IconX size={15} />;
    default:
      return null;
  }
};

export const ContractorStatus = ({ variant = 'VERIFIED', children }: IMatchStatus) => {
  const classNames = clsx('inline-flex rounded-full px-2.5 py-1 text-xs font-medium', variantStyle[variant]);

  return (
    <div className={classNames}>
      <span className="flex flex-row flex-nowrap items-start justify-center gap-1 self-start overflow-hidden text-ellipsis">
        {getIconForStatus(variant)}
        {children}
      </span>
    </div>
  );
};

ContractorStatus.displayName = 'ContractorStatus';
